import { useMediaQuery } from 'react-responsive';

const useDeviceInfo = () => {
  const isLargeScreen = useMediaQuery({ query: '(min-width: 1440px)' });
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1024px)' });
  const isDL = useMediaQuery({ query: '(max-width: 1300px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' });

  return {
    isDesktopOrLaptop,
    isTabletOrMobile,
    isLargeScreen,
    isDL,
  };
};

export default useDeviceInfo;
